export default __webpack_public_path__ + "static/value4-b8733436e5eae36695fcf43869e4d2c5.webp";